export function adjustPercentile(value){
    //Don't touch null or undefined
    if(!value && value !== 0){
      return value;
    }

    let outValue = value;
    outValue = Math.round(outValue);

    //Make sure our floor is 1
    return outValue === 0 ? 1 : outValue;
  }